import { Component } from '@angular/core';

@Component({
  selector: 'app-nested-page-block',
  templateUrl: './nested-page-block.component.html',
})
export class NestedPageBlockComponent {}
